<div class="layout-corral">
    <div class="jumbotron-img" *ngIf="pictURL">
        <img [src]="pictURL" alt="">
    </div>
    <div  class="jumbotron-board">
        <div class=" jumbotron-registeries">
            <a href="uvedomlenie-o-razrabotke"><h2>Разработка стандартов</h2></a>
            <div *ngFor="let entry of entries"> 
                    <div class="">
                        <span *ngIf="entry.notificationDate" class="notification-date">{{entry.notificationDate | date : 'dd.MM.yyyy'}}&emsp;</span>
                        <span *ngIf="entry.yearInclusion" class="year-inclusion">{{entry.yearInclusion}}&emsp;</span>
                        <span>{{entry.type}}&emsp;</span>
                        <span class="subcommittee">{{entry.subcommittee}}</span>
                    </div>

    
                    <div class="name">
                        <a [routerLink]="entry.page">{{entry.name}}</a>
                    </div>
    
                    <div *ngIf="entry.startDiscussion" class="discussion">
                        <span class="start-discussion">{{entry.startDiscussion | date : 'dd.MM.yyyy'}}</span> -
                        <span class="end-discussion">{{entry.endDiscussion | date : 'dd.MM.yyyy'}}</span>
                    </div>            
    
                    <div *ngIf="entry.documentType">
                        <span class="document-type">{{entry.documentType}}&emsp;</span>
                        <span class="designation">{{entry.designation}}&emsp;</span>
                        <span class="order">{{entry.order}}</span>
                    </div>
                    <br>
               
            </div>
        </div>
        <div class=" jumbotron-news">
            <a href="novosti"><h2>Новости</h2></a>

            <div *ngFor="let pub of news">

                    <span class="pub-date">{{pub.date}}&emsp;</span>
                    <a [routerLink]="pub.link ">{{pub.name}}&emsp;</a><br>           
            </div>
        </div>
    
    </div>
</div>

